/**
 * Occupancy Query Hook (Epic C-4 — Bezetting & conflicten, Story C-4.1)
 *
 * Eigen bestand, zelfde query-keys-factory-conventie als
 * `usePlanningBoard.ts` (AD-9/AD-18). Consumeert `planningApi.getOccupancy`
 * (C-4.1).
 */

import { useQuery } from '@tanstack/react-query';
import { planningApi } from '../../../lib/planningApi';
import type { PlanningOccupancyGranularity } from '@functieloonhuis/shared';

export const occupancyKeys = {
  all: ['planningOccupancy'] as const,
  occupancy: (van: string, tot: string, departmentId?: number, granularity?: PlanningOccupancyGranularity) =>
    [...occupancyKeys.all, van, tot, departmentId ?? null, granularity ?? 'week'] as const,
};

export function useOccupancy(van: string, tot: string, departmentId?: number, granularity: PlanningOccupancyGranularity = 'week') {
  return useQuery({
    queryKey: occupancyKeys.occupancy(van, tot, departmentId, granularity),
    queryFn: () => planningApi.getOccupancy(van, tot, departmentId, granularity),
    enabled: !!van && !!tot,
  });
}
